module.exports = __webpack_public_path__ + "static/img/store-frame.e66d9362.png";